import * as React from 'react'

import * as hooks from '@owl-nest/hooks'
import { usePageView } from '@boutique/shadow'

import { HITS_PER_PAGE, useProductListing } from './hooks/useProductListing'
import * as results from '../components/Results'

export function Results(): React.ReactElement {
  const { response } = useProductListing()

  usePageView([
    'category',
    'brands',
    'colors',
    'environmentalPillar',
    'gender',
    'searchableTag',
    'moments',
    'sizes',
    'socialPillar',
    'types',
    'vendors',
  ])

  const data = hooks.data(response)
  const lengthRef = React.useRef(data?.hits.length)

  if (data === undefined) {
    return <results.ResultsSkeleton length={lengthRef.current ?? HITS_PER_PAGE} />
  }

  if (response.status === hooks.QueryStatus.FAILURE) return <></>

  // NOTE: we're already rendering ProductPlaceholders if data is loading, so this case should not happen
  if (data === undefined) return <></>

  if (data.nbHits === 0) {
    lengthRef.current = 3
    return <results.EmptyResults />
  } else {
    lengthRef.current = data?.hits.length
  }

  return <results.Results products={data.hits} />
}
